import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "./Modal.scss"; // Reuse existing modal styles
import Cross from "../../assets/images/cross.png";

const EmailVerificationModal = ({ show, onClose, email }) => {
  const { resendVerification } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [resendError, setResendError] = useState("");

  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [show]);

  const handleResendVerification = async () => {
    if (!email) {
      setResendError("Email address is required");
      return;
    }

    setIsResending(true);
    setResendError("");
    setResendMessage("");

    try {
      await resendVerification(email);
      setResendMessage("Un nouveau lien de vérification a été envoyé à votre email.");
    } catch (err) {
      console.error("Failed to resend verification email:", err);
      setResendError(
        err?.response?.data?.detail ||
          "Impossible d'envoyer un nouveau lien de vérification. Veuillez réessayer."
      );
    } finally {
      setIsResending(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="header-buttons" style={{ fontSize: "24px", color: "#5200FF" }}>
            Vérifiez votre email
          </div>
          <button className="close-icon" onClick={onClose}>
            <img src={Cross} alt="close" />
          </button>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: "24px", lineHeight: 1.5 }}>
            Nous avons envoyé un lien de vérification à votre adresse email. Veuillez vérifier
            votre boîte de réception (et éventuellement vos spams) puis cliquer sur ce lien
            pour activer votre compte.
          </p>
          
          {resendMessage && (
            <p style={{ 
              marginBottom: "16px", 
              padding: "12px", 
              backgroundColor: "#f0f9ff", 
              border: "1px solid #91caff", 
              borderRadius: "4px",
              color: "#1677ff"
            }}>
              {resendMessage}
            </p>
          )}
          
          {resendError && (
            <p style={{ 
              marginBottom: "16px", 
              padding: "12px", 
              backgroundColor: "#fff2f0", 
              border: "1px solid #ffccc7", 
              borderRadius: "4px",
              color: "#ff4d4f"
            }}>
              {resendError}
            </p>
          )}
          
          <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
            <button
              className="btn-submit auth-button"
              type="button"
              style={{ flex: 1 }}
              onClick={handleResendVerification}
              disabled={isResending}
            >
              {isResending ? "Envoi..." : "Renvoyer le lien"}
            </button>
          </div>
          
          <button
            className="btn-submit auth-button"
            type="button"
            style={{ width: "100%" }}
            onClick={onClose}
          >
            J'ai compris
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal; 